/* maligo® – Gratis-Probe der anderen Textur automatisch im Warenkorb halten.
   Regeln (Maui, 14.10.2026): Butter-Probe zu Jelly 12/30 ml, Jelly-Probe zu Butter 30 ml,
   nie zu Jelly 250 ml, eine pro Textur und Bestellung, keine Probe wenn beide Texturen im Warenkorb.
   Der Preis (€6,90) wird per automatischem Shopify-Rabatt auf 0 gesetzt. */
(() => {
  if (window.maligoProbes) return;

  const BUTTER_PROBE = 59892774568281;
  const JELLY_PROBE = 59892774928729;
  // Werbe-Kit (Maui 16.10.2026): je Textur eins, Wert 19 € per automatischem Rabatt auf 0
  // Jelly: ab 3 Trays 30 ml (072/096/120) oder ab 90 Stück 12 ml (090/120), nie 250 ml · Butter: ab 3 Trays (081/108/135)
  const KIT_JELLY = 59937713160537;
  const KIT_BUTTER = 59937714045273;
  const KIT_JELLY_SKU = /^MLG-J30-[A-Z]+-(072|096|120)$|^MLG-J12-[A-Z]+-(090|120)$/;
  const KIT_BUTTER_SKU = /^MLG-BP?30-[A-Z]+-(081|108|135)$/; // Butter + Butter Pure
  const JELLY_ANY = /^MLG-J(12|30|250)-/;
  const JELLY_WITH_PROBE = /^MLG-J(12|30)-/;
  const BUTTER = /^MLG-BP?30-/; // Butter + Butter Pure (Jelly-Probe dazu)
  const OWN = { 'X-Maligo-Probe': '1' };

  let running = null;

  async function sync() {
    if (running) return running;
    running = (async () => {
      const cart = await (await fetch('/cart.js', { headers: OWN })).json();
      const skus = cart.items.map((item) => item.sku || '');
      const hasJelly = skus.some((s) => JELLY_ANY.test(s));
      const hasJellyWithProbe = skus.some((s) => JELLY_WITH_PROBE.test(s));
      const hasButter = skus.some((s) => BUTTER.test(s));

      const want = {
        [BUTTER_PROBE]: hasJellyWithProbe && !hasButter ? 1 : 0,
        [JELLY_PROBE]: hasButter && !hasJelly ? 1 : 0,
        [KIT_JELLY]: skus.some((s) => KIT_JELLY_SKU.test(s)) ? 1 : 0,
        [KIT_BUTTER]: skus.some((s) => KIT_BUTTER_SKU.test(s)) ? 1 : 0
      };
      const have = {};
      cart.items.forEach((item) => {
        if (item.variant_id in want) have[item.variant_id] = (have[item.variant_id] || 0) + item.quantity;
      });

      const updates = {};
      Object.keys(want).forEach((id) => {
        if ((have[id] || 0) !== want[id]) updates[id] = want[id];
      });
      if (!Object.keys(updates).length) return false;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...OWN },
        body: JSON.stringify({ updates })
      });
      return true;
    })().finally(() => {
      running = null;
    });
    return running;
  }

  async function refreshCart() {
    if (document.body.classList.contains('template-cart') || location.pathname.endsWith('/cart')) {
      location.reload();
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    const res = await fetch(`${location.pathname}?sections=cart-drawer,cart-icon-bubble`, { headers: OWN });
    const sections = await res.json();
    const cart = await (await fetch('/cart.js', { headers: OWN })).json();
    // wie product-form.js im Theme: Leer-Zustand der Schublade selbst umschalten
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    drawer.renderContents({ id: null, sections });
  }

  // Änderungen im Warenkorb (Menge, Entfernen) durch das Theme beobachten
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const response = await nativeFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : input.url;
      const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
      if (/\/cart\/(change|update|clear)/.test(url) && !headers.has('X-Maligo-Probe')) {
        response.clone().text().then(async () => {
          if (await sync()) refreshCart();
        });
      }
    } catch (e) {
      /* Probe-Sync darf den Warenkorb nie blockieren */
    }
    return response;
  };

  window.maligoProbes = { sync, refreshCart };
})();
